import { SUITS, RANKS, cardId } from "@/lib/deck";
import { cn } from "@/lib/utils";

export function CardGrid({ deckCount, counts, onDeal }) {
  return (
    <div className="space-y-6" data-testid="card-grid">
      {SUITS.map((suit) => (
        <div key={suit.id} data-testid={`suit-section-${suit.id}`}>
          <div className="flex items-center gap-2 mb-2">
            <span
              className={cn(
                "text-xl leading-none",
                suit.color === "red" ? "text-suit-red" : "text-suit-black"
              )}
              aria-hidden="true"
            >
              {suit.symbol}
            </span>
            <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
              {suit.label}
            </span>
          </div>
          <div className="grid grid-cols-7 sm:grid-cols-13 gap-1.5">
            {RANKS.map((rank) => {
              const id = cardId(suit.id, rank);
              const remaining = counts[id] ?? 0;
              const dealt = remaining <= 0;
              return (
                <button
                  key={id}
                  type="button"
                  data-testid={`card-${suit.id}-${rank}`}
                  aria-label={`${rank} of ${suit.label}, ${remaining} remaining`}
                  disabled={dealt}
                  onClick={() => onDeal(id)}
                  className={cn(
                    "relative aspect-[3/4] flex flex-col items-center justify-center select-none",
                    "border-2 border-foreground bg-card font-mono font-bold",
                    "transition-[transform,box-shadow,opacity] duration-75",
                    !dealt &&
                      "hover:-translate-y-1 hover:shadow-brutal active:translate-y-0 active:shadow-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background cursor-pointer",
                    dealt && "opacity-20 scale-95 cursor-not-allowed"
                  )}
                >
                  <span
                    className={cn(
                      "text-base sm:text-lg leading-none",
                      suit.color === "red" ? "text-suit-red" : "text-suit-black"
                    )}
                  >
                    {rank}
                  </span>
                  <span
                    className={cn(
                      "text-xs leading-none mt-0.5",
                      suit.color === "red" ? "text-suit-red" : "text-suit-black"
                    )}
                    aria-hidden="true"
                  >
                    {suit.symbol}
                  </span>
                  {deckCount > 1 && !dealt && (
                    <span
                      data-testid={`card-badge-${suit.id}-${rank}`}
                      className="absolute -top-2 -right-2 min-w-[1.1rem] h-[1.1rem] px-1 flex items-center justify-center text-[0.6rem] font-bold bg-foreground text-background rounded-full"
                    >
                      {remaining}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
